module.exports = __webpack_public_path__ + "media/images/lb/354-b3de2bea25cbe19365eb91012602656f.svg";